import { capitalizeNamePart, capitalizeWords, formatFullName, formatWithLastInitial } from './playerUtils';

export const ensureGuestInfoShape = (info) => {
    if (!info || typeof info !== 'object') return null;

    const firstRaw = info.firstName ?? info.first_name ?? '';
    const lastRaw = info.lastName ?? info.last_name ?? '';
    const phoneRaw = info.phone ?? info.phoneNumber ?? info.phone_number ?? null;
    const levelRaw = info.level ?? info.levelName ?? info.level_name ?? null;
    const nameRaw = info.name ?? info.fullName ?? info.full_name ?? '';

    const firstName = capitalizeNamePart(firstRaw);
    const lastName = capitalizeNamePart(lastRaw);
    const phone = phoneRaw == null || phoneRaw === '' ? null : phoneRaw;
    const level = levelRaw == null || levelRaw === '' ? null : levelRaw;
    const fallbackName = capitalizeWords(nameRaw);
    const name = fallbackName || formatFullName(firstName, lastName);

    return {
        firstName,
        lastName,
        phone,
        level,
        name,
    };
};

const extractGuestInfoFromRegistration = (registration) => {
    const guestObj = registration && typeof registration.guest === 'object' ? registration.guest : null;

    return (
        registration?.guestInfo ??
        guestObj ??
        (registration &&
        (registration.guestFirstName ||
            registration.guestLastName ||
            registration.guestName ||
            registration.guest_first_name ||
            registration.guest_last_name)
            ? {
                  firstName: registration?.guestFirstName ?? registration?.guest_first_name ?? '',
                  lastName: registration?.guestLastName ?? registration?.guest_last_name ?? '',
                  phone: registration?.guestPhone ?? registration?.guest_phone ?? null,
                  level: registration?.guestLevel ?? registration?.guest_level ?? null,
                  name: registration?.guestName ?? registration?.guest_name ?? '',
              }
            : null)
    );
};

export const formatRegistrationName = (registration, formatPlayerName) => {
    if (!registration) return 'Jugadora invitada';

    const guestInfoRaw = extractGuestInfoFromRegistration(registration);
    const guestInfo = ensureGuestInfoShape(guestInfoRaw);

    if (guestInfo) {
        const formatted = formatWithLastInitial(guestInfo.firstName, guestInfo.lastName);
        if (formatted) return formatted;
        if (guestInfo.name) return guestInfo.name;
        return 'Jugadora invitada';
    }

    const playerNameRaw = (registration.playerName ?? registration.player_name ?? '').trim();
    if (playerNameRaw) {
        const [first, ...rest] = playerNameRaw.split(/\s+/);
        const formattedPlayer = formatWithLastInitial(first, rest.join(' '));
        return formattedPlayer || capitalizeWords(playerNameRaw);
    }

    return formatPlayerName(registration.playerId ?? registration.player_id);
};
